const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  }, {
    path: ["/services", "/Services"],
    exact: true,
    component: "Services",
  },
  {
    path: ["/about", "/About"],
    exact: true,
    component: "About",
  },
  {
    path: ["/contact", "/Contact"],
    exact: true,
    component: "Contact",
  },
  {
    path: ["/atlassianapps", "/AtlassianApps"],
    exact: true,
    component: "AtlassianApps",
  },
  {
    path: ["/AtlassianApps/JRB", "/AtlassianApps/JRB"],
    exact: true,
    component: "AtlassianApps/JRB",
  },
  {
    path: ["/AtlassianApps/JTL", "/AtlassianApps/JTL"],
    exact: true,
    component: "AtlassianApps/JTL",
  },
  {
    path: ["/AtlassianApps/JLV", "/AtlassianApps/JLV"],
    exact: true,
    component: "AtlassianApps/JLV",
  },
  {
    path: ["/AtlassianApps/CLV", "/AtlassianApps/CLV"],
    exact: true,
    component: "AtlassianApps/CLV",
  },
  {
    path: ["/AtlassianApps/CAS", "/AtlassianApps/CAS"],
    exact: true,
    component: "AtlassianApps/CAS",
  },
  {
    path: ["/AtlassianApps/BLV", "/AtlassianApps/BLV"],
    exact: true,
    component: "AtlassianApps/BLV",
  },
  {
    path: ["/AtlassianApps/JCR", "/AtlassianApps/JCR"],
    exact: true,
    component: "AtlassianApps/JCR",
  },
  {
    path: ["/AtlassianApps/JDC", "/AtlassianApps/JDC"],
    exact: true,
    component: "AtlassianApps/JDC",
  },
  {
    path: ["/AtlassianApps/JDU", "/AtlassianApps/JDU"],
    exact: true,
    component: "AtlassianApps/JDU",
  },
  {
    path: ["/AtlassianApps/JAS", "/AtlassianApps/JAS"],
    exact: true,
    component: "AtlassianApps/JAS",
  },
  {
    path: ["/AtlassianApps/JIT", "/AtlassianApps/JIT"],
    exact: true,
    component: "AtlassianApps/JIT",
  },
  {
    path: ["/privacy", "/privacy"],
    exact: true,
    component: "Policy/Privacy",
  },
  {
    path: ["/atlassianSLA", "/sla"],
    exact: true,
    component: "Policy/SLA",
  },
  {
    path: ["/atlassianEULA", "/eula"],
    exact: true,
    component: "Policy/EULA",
  },
  {
    path: ["/IMPRINT", "/imprint"],
    exact: true,
    component: "Policy/Imprint",
  },
  {
  path: '/sitemap',
  exact: true,
  component: 'Sitemap' // or lazy import it if needed
}

];

export default routes;
